import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    lineHeight: defaultTheme.font.height.base,
    minWidth: '320px',
  }),
);

export const Time = styled.span(() =>
  mq({
    fontSize: [defaultTheme.font.size.xs, defaultTheme.font.size.s],
    marginRight: defaultTheme.spacing.s,
    time: {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const ReleaseStatus = styled.span(() =>
  mq({
    fontSize: [defaultTheme.font.size.xs, defaultTheme.font.size.s],
  }),
);
